<template>
  <div :class="rowClass">
    <div v-if="haveArrows" class="vertical-center arrow pointer" @click.passive="scroll(1)" ref="arrowPlus">
      <img src="@/assets/icons/home-carrusel-right-arrow.png" />
    </div>
    <div class="text-nowrap flex-grow-1" :style="style" ref="scrollcontainer">
      <slot></slot>
    </div>
    <div v-if="haveArrows" class="vertical-center arrow pointer" @click.passive="scroll(-1)" ref="arrowMinus">
      <img src="@/assets/icons/home-carrusel-left-arrow.png" />
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  props: {
    rightJustify: Boolean,
    allowOverflow: {
      type: Boolean,
      default: false
    },
    centerObjects: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      haveArrows: false,
      containerHeight: 39,
      step: 395
    }
  },
  computed: {
    style() {
      if (this.haveArrows) {
        if (this.allowOverflow) {
          if (this.$isDesktop()) {
            return "";
          }
          else {
            return {  height: `${this.containerHeight}px`, 'overflow': 'hidden' };
          }
        } 
        else {
          return "overflow:hidden;";
        }
      }
      else {
        if (this.allowOverflow) {
          if (this.$isDesktop()) {
            return "";
          }
          else {
            return {  height: `${this.containerHeight}px`, 'overflow-x': 'scroll', 'overflow-y': 'hidden' };
          }
        
        } else {
          return "overflow-x: scroll; overflow-y: hidden;";
        }

      }
    },
    rowClass() {
      return "d-flex flex-row position-relative" + (this.centerObjects ? " text-center" : "");
    }
  },
  methods: {
    initArrows() {
      const scrollcontainer = this.$refs["scrollcontainer"];
      const arrowPlus = this.$refs["arrowPlus"];
      const arrowMinus = this.$refs["arrowMinus"];
      var rightJustify = this.rightJustify || false
      if (scrollcontainer.scrollLeft >= 0) {
        arrowPlus.classList.add('hide');
      }
      
      if (scrollcontainer.scrollWidth <= scrollcontainer.clientWidth) {
        arrowMinus.classList.add('hide');
        if ( !rightJustify ) {
          scrollcontainer.classList.add('text-center');
        }
      }

    },
    updateContainerHeight(visible) {
      this.$nextTick(() => {
        const children = this.$refs.scrollcontainer.children;
        let maxHeight = 39;
        if (visible) {
          for (let i = 0; i < children.length; i++) {
          const child = children[i];
          const innerpopup = child.querySelector('[class*="innerpopup"]'); // Find the child element with class "innerpopup"
          if (innerpopup) {
            const innerpopupHeight = innerpopup.offsetHeight;
              if (innerpopupHeight > maxHeight) {
                maxHeight = innerpopupHeight + 40;
              }
            }
          }
        }
        this.containerHeight = maxHeight;  
      });
    },
    scroll(byVal) {
      this.scrollSmooth(Date.now(), byVal * this.step);
    },
    scrollSmooth(startTime, targetPx) {
      const TIME = 300; //how long action should take
      const scrollcontainer = this.$refs["scrollcontainer"];
      const initialScrollLeft = scrollcontainer.scrollLeft;
      const targetPosition = initialScrollLeft + targetPx;
      this.scroll2(TIME, scrollcontainer, initialScrollLeft, targetPosition, startTime, targetPx);

    },
    scroll2(TIME, scrollcontainer, initialScrollLeft, targetPosition, startTime, targetPx) {
      const timePassed = Date.now() - startTime;
      const percentElapsed = timePassed / TIME;
      if (percentElapsed >= 1) {
        scrollcontainer.scrollLeft += targetPx;
        this.updateArrows();
        return;
      }

      window.setTimeout(function () {
        const easeQuadOutput = percentElapsed * percentElapsed;
        const scrollPosition = easeQuadOutput * targetPx;
        scrollcontainer.scrollLeft = initialScrollLeft + scrollPosition;
        this.scroll2(TIME, scrollcontainer, initialScrollLeft, targetPosition, startTime, targetPx);
      }.bind(this), 0);
    },
    updateArrows() {
      if (this.haveArrows) {
        const scrollcontainer = this.$refs["scrollcontainer"];
        const arrowPlus = this.$refs["arrowPlus"];
        const arrowMinus = this.$refs["arrowMinus"];
        if (scrollcontainer.scrollLeft < 0) {
          arrowPlus.classList.remove('hide');
        } else {
          arrowPlus.classList.add('hide');
        }
        // if ((scrollcontainer.scrollLeft * -1) + this.step >= scrollcontainer.clientWidth) {
        // const initialScrollLeft = scrollcontainer.scrollLeft;
        // const newScrollLeft = scrollcontainer.scrollLeft;
        // if (newScrollLeft <= initialScrollLeft) {
        //   arrowMinus.classList.add('hide');
        // } else {
        //   arrowMinus.classList.remove('hide');
        // }
      }
    },
    scrollSmooth2(step, tillNow, target) {
      // console.log("smooth scroll:", step, tillNow, target);
      if (target > 0 && tillNow >= target) return;
      if (target < 0 && tillNow <= target) return;
      tillNow += step;
      window.setTimeout(function () {
        this.scrollAction(step);
        let nextStep = step / 2;
        if (nextStep < 0 && nextStep > -5) nextStep = -5;
        if (nextStep > 0 && nextStep < 5) nextStep = 5;
        this.scrollSmooth(nextStep, tillNow, target);
      }.bind(this), 0);
    },
    scrollAction(byVal) {
      const scrollcontainer = this.$refs["scrollcontainer"];
      const arrowPlus = this.$refs["arrowPlus"];
      const arrowMinus = this.$refs["arrowMinus"];
      const initialScrollLeft = scrollcontainer.scrollLeft;
      const stepSize = byVal; // (byVal * this.step);
      scrollcontainer.scrollLeft += stepSize;
      const newScrollLeft = scrollcontainer.scrollLeft;
    },
    promostyle(img) {
      return "width: " + img.width + "px; height: " + img.height + "px;";
    }
  },
  async mounted() {
     if (this.allowOverflow && !this.$isDesktop()) {
      this.updateContainerHeight(false);
      this.emitter.on("expandContainer", (visible) => {
        this.updateContainerHeight(visible);
      });
    }
    if (this.$isDesktop(true)) {
      this.haveArrows = true;
      await this.$nextTick();
      this.initArrows();
    } else {
      this.step = 40;
    }
    

    // if (this.$props.arrows) {
    //   const arrowPlus = this.$refs["arrowPlus"];
    //   arrowPlus.classList.add("hide");
    // }
  },
  unmounted() {
    this.emitter.off("expandContainer");
  },
    

}
</script>
<style scoped>
.hide {
  visibility: hidden;
}
.vertical-center {
  position: relative;
}

.vertical-center img {
  position: relative;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.arrow img {
  /* position: absolute;
  left: 10px; */
  z-index: 100;
  /* background-color: green; */
}
</style>